import { Injectable } from '@angular/core';
import { AssetClass } from '../models/enums/asset-class.enum';

@Injectable({
    providedIn: 'root',
})
export class AssetClassService {
    getDashboardType(assetClasses: string[]): AssetClass {
        if (assetClasses.length === 0) return AssetClass.PrivateEquity;
        if (assetClasses.every(c => c === AssetClass.RealEstate)) return AssetClass.RealEstate;
        if (assetClasses.every(c => c === AssetClass.Infrastructure)) return AssetClass.Infrastructure;
        return AssetClass.PrivateEquity;
    }
}
